<script>
    import novelLogo from "./assets/novel.svg";
</script>

<div class="max-w-4xl mx-auto px-6 md:px-16 flex flex-col items-center text-center">
    <p class="text-sm font-semibold text-purple-sub uppercase tracking-widest mb-3">News</p>
    <h2 class="text-[38px] font-semibold text-navy">
        Novel & SmartClaim Integration
    </h2>
    <p class="mt-4 text-lg text-purple-sub max-w-xl">
        We've worked with Novel to bring AI technical narrative drafting directly into the Novel platform.
    </p>
    <div class="mt-10 w-full max-w-lg bg-white rounded-2xl border border-card-border shadow-purple-card p-6">
        <img
            src={novelLogo}
            alt="Novel & SmartClaim Partnership"
            class="w-full object-contain"
        />
    </div>
</div>
